import { getRequest } from '../services/requestHandler';
import { HeadWeightLocationBackDto } from '../models';

export const getHeadWeightLocationBack = async () => {
  const response = await getRequest<Omit<HeadWeightLocationBackDto, 'headWeightLocationBackId'>>('GetHeadWeightLocationsBack', 'headWeight/GetHeadWeightLocationsBack?useCache=false');
  return response.map((row, index) => ({ ...row, headWeightLocationBackId: index }));
};
